import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Page } from './fca-page/page.component';
import { DataTable } from './fca-data-table';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { AccessForbiddenComponent } from './access-forbidden/access-forbidden.component';
import { DataImportDialogComponent } from './data-import-dialog/data-import-dialog.component';
import { MatListModule } from '@angular/material/list';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FilterSearchComponent } from './filter-search';
import { MatBadgeModule } from '@angular/material/badge';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTabsModule } from '@angular/material/tabs';

@NgModule({
  declarations: [
    Page,
    DataTable,
    BreadcrumbComponent,
    AccessForbiddenComponent,
    DataImportDialogComponent,
    FilterSearchComponent,
  ],
  imports: [
    CommonModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatDividerModule,
    MatListModule,
    NgxMatSelectSearchModule,
    MatBadgeModule,
    MatCardModule,
    MatDatepickerModule,
    MatTabsModule
  ],
  exports: [
    Page,
    DataTable,
    BreadcrumbComponent,
    FilterSearchComponent,
    MatCardModule,
    MatIconModule,
    MatCheckboxModule,
    MatTooltipModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    MatSelectModule,
    MatTabsModule
  ],
})
export class SharedModule {}
